//src/pages/admin/components/RichText.jsx

import React from 'react';

// очень лёгкая "санитизация": вырезаем <script>/<style> и on* атрибуты
function sanitize(html = '') {
  const d = document.createElement('div');
  d.innerHTML = html;
  // remove script/style
  d.querySelectorAll('script,style').forEach(n => n.remove());
  // strip on* attributes
  d.querySelectorAll('*').forEach(el => {
    [...el.attributes].forEach(attr => {
      if (/^on/i.test(attr.name)) el.removeAttribute(attr.name);
    });
  });
  return d.innerHTML;
}

function wordCountFromHTML(html=''){
  const text = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  if (!text) return 0;
  return text.split(' ').length;
}

export default function RichText({
  value = '',
  onChange,
  placeholder = 'Введите описание…',
  minHeight = 160,
}) {
  const ref = React.useRef(null);

  // синхронизируем внешний value → DOM
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (sanitize(el.innerHTML) !== sanitize(value || '')) {
      el.innerHTML = value || '';
    }
  }, [value]);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    handleInput(); // пересчёт
  };

  const handleInput = () => {
    const el = ref.current;
    if (!el) return;
    const next = sanitize(el.innerHTML);
    onChange?.(next);
  };

  const handlePaste = (e) => {
    // вставка как "plain text"
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text');
    document.execCommand('insertText', false, text);
    handleInput();
  };

  const wc = wordCountFromHTML(value || '');

  return (
    <div>
      <div style={{display:'flex', gap:8, flexWrap:'wrap', marginBottom:8}}>
        <button type="button" className="btn" onClick={()=>exec('formatBlock', '<h3>')}>H3</button>
        <button type="button" className="btn" onClick={()=>exec('formatBlock', '<p>')}>P</button>
        <button type="button" className="btn" onClick={()=>exec('bold')}>B</button>
        <button type="button" className="btn" onClick={()=>exec('italic')}>I</button>
        <button type="button" className="btn" onClick={()=>exec('insertUnorderedList')}>• Список</button>
        <button type="button" className="btn" onClick={()=>exec('insertOrderedList')}>1. Список</button>
        <button type="button" className="btn" onClick={()=>{
          const url = prompt('Ссылка (http...)');
          if (!url) return;
          exec('createLink', url);
        }}>Ссылка</button>
        <button type="button" className="btn" onClick={()=>{
          const el = ref.current;
          if (!el) return;
          el.innerHTML = sanitize(el.textContent || '');
          onChange?.(el.innerHTML);
        }}>Очистить формат</button>
        <span style={{marginLeft:'auto', color:'var(--muted)'}}>Слов: {wc}</span>
      </div>

      <div
        ref={ref}
        role="textbox"
        contentEditable
        onInput={handleInput}
        onPaste={handlePaste}
        style={{
          minHeight,
          border:'1px solid var(--bdr)',
          borderRadius:12,
          padding:12,
          background:'var(--card)',
          boxShadow:'var(--shadow)',
          outline:'none',
          lineHeight:1.5
        }}
        data-placeholder={placeholder}
        // маленький трюк для placeholder
        onBlur={handleInput}
        suppressContentEditableWarning
      />
      <style>{`
        [contenteditable][data-placeholder]:empty:before{
          content: attr(data-placeholder);
          color: var(--muted);
        }
      `}</style>
    </div>
  );
}
